import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import {
  fetchOrganisationError,
  fetchOrganisationStart,
  fetchPlansError,
  fetchPlansStart,
  fetchUsersError,
  fetchUsersStart,
  setOrganisationData,
  setPlansData,
  setUsersData,
} from '../reducers/organizationReducer';
import { OrganizationService } from '../services';
import { SortOrder } from '../types';

export const useFetchUsers = (
  search?: string,
  sortBy?: string,
  sortOrder?: SortOrder,
  status?: string,
) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.organization);

  const fetchUsers = async () => {
    if (loading) return;

    const statusFilter = status ?? localStorage.getItem('statusFilter') ?? 'active';

    dispatch(fetchUsersStart());
    const { data: { items } = {}, error } = await OrganizationService.getUsers(
      search,
      sortBy,
      sortOrder?.toUpperCase(),
      statusFilter,
    );

    if (items) {
      dispatch(setUsersData(items));
    } else if (error) {
      dispatch(fetchUsersError(error));
    }
  };

  return fetchUsers;
};

export const useFetchPlans = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.organization);

  const fetchPlans = async () => {
    if (loading) return;

    dispatch(fetchPlansStart());

    const { data, error } = await OrganizationService.organizationPlans();

    if (data) {
      dispatch(setPlansData(data));
    } else if (error) {
      dispatch(fetchPlansError(error));
    }
  };

  return fetchPlans;
};

export const useFetchOrganisation = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.organization);

  const fetchOrganisation = async () => {
    if (loading) return;

    dispatch(fetchOrganisationStart());

    const { data, error } = await OrganizationService.organisation();

    if (data) {
      dispatch(setOrganisationData(data));
    } else if (error) {
      dispatch(fetchOrganisationError(error));
    }
  };

  return fetchOrganisation;
};
